var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-loading-sidebar-sending",staticStyle:{"background":"#ffffff"}},[_c('Circle2',{staticClass:"spinner-social-sidebar-sending"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }